import { useIntl } from '@weenat/wintl'
import Text from 'app/src/kit/Text'
import { isNil } from 'lodash-es'
import { memo } from 'react'
import { styled } from 'styled-components'
import Grid from '../kit/Grid'
import NetworkHeadquarterMap from './NetworkHeadquarterMap'
import { NetworkPresentationCommonProps } from './NetworkPresentationLayoutTools'

const MapOnGridHolder = styled.div`
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 3;
`

const MetricCardOnGridHolder = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: stretch;

  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 2;
  grid-row-end: 3;
`

const DeviceCardOnGridHolder = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: stretch;

  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 2;
`

const NumberCard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  background-color: ${(p) => p.theme.colors.grayscale[100]};
  border-radius: ${(p) => p.theme.radiuses.md}px;
  padding: 16px;
  border: 1px solid ${(p) => p.theme.colors.grayscale[300]};

  box-shadow: none;
`

const StatisticCard: FC<{ value: number; label: string }> = ({ value, label }) => {
  return (
    <NumberCard>
      <Text $fontSize='xl' $fontWeight='bold'>
        {value}
      </Text>
      <Text>{label}</Text>
    </NumberCard>
  )
}

const NetworkResumeSection: FC<NetworkPresentationCommonProps> = ({ network }) => {
  const { t } = useIntl()

  return (
    <Flex $flexDirection='column' $p='lg' $gap='lg'>
      <Text $fontSize='lg' $fontWeight='bold'>
        {t('models.network.misc.network_in_numbers')}
      </Text>

      <Grid $templateRows='1fr 1fr' $templateColumns='1fr 1fr' $gap={'lg'}>
        <DeviceCardOnGridHolder>
          <StatisticCard
            value={network.deviceCount}
            label={t('models.network.misc.setup_weather_stations')}
          />
        </DeviceCardOnGridHolder>

        <MetricCardOnGridHolder>
          <StatisticCard
            value={network.adherentFarmsCount}
            label={t('models.network.misc.adherent_organizations')}
          />
        </MetricCardOnGridHolder>

        <MapOnGridHolder>
          {!isNil(network?.headquarter) ? (
            <NetworkHeadquarterMap hqLocation={network.headquarter.location} />
          ) : null}
        </MapOnGridHolder>
      </Grid>
    </Flex>
  )
}

export default memo(NetworkResumeSection)
